/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetCardTransactionDetails200ResponseTransactionRecordListInner
 */
export interface GetCardTransactionDetails200ResponseTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionDetails200ResponseTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionDetails200ResponseTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionDetails200ResponseTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionDetails200ResponseTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200ResponseTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactionDetails200ResponseTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200ResponseTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactionDetails200ResponseTransactionRecordListInner
     */
    'transactionDetailType': GetCardTransactionDetails200ResponseTransactionRecordListInnerTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactionDetails200ResponseTransactionRecordListInner
     */
    'isCleared': boolean;
}

export const GetCardTransactionDetails200ResponseTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type GetCardTransactionDetails200ResponseTransactionRecordListInnerTransactionDetailTypeEnum = typeof GetCardTransactionDetails200ResponseTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof GetCardTransactionDetails200ResponseTransactionRecordListInnerTransactionDetailTypeEnum];


